/**
 * Matches a path against a rule. `*` is a wildcard matching any (possibly
 * empty) substring and can appear anywhere in the rule.
 *
 * Deliberately duplicated from `middleware/shouldServeNexus.ts`, which the
 * Vercel middleware bundle depends on and so must stay import-free.
 */
export function wildcardMatch(rule: string, path: string): boolean {
  const escape = (s: string) => s.replace(/[.+?^$()|[\]{}\\]/g, String.raw`\$&`)
  const pattern = rule.split("*").map(escape).join(".*")
  return new RegExp(`^${pattern}$`).test(path)
}
